// extracted by mini-css-extract-plugin
export var btn = "R_mY K_wd K_v4 d_bz d_bP d_bD d_dw";
export var full = "R_xs d_w d_H";
export var hoverStyle = "R_m1";
export var zoom = "R_m2";